export function TMap() {
    return new Promise(function(resolve, reject) {
      window.init = function() {
        resolve(qq)
      }
      var script = document.createElement('script')
      script.type = 'text/javascript'
      script.src = 'http://map.qq.com/api/js?v=2.exp&callback=init&key=ZKHBZ-F3SR4-FKKUU-X6TEB-F5EB6-LLB3D'
      script.onerror = reject
      document.head.appendChild(script)
    })
  }